import { DataTableProvider } from 'components/DataTable'
import { IColumnVisibility } from 'components/DataTable/types'

import { ChainsSummary } from 'models/summaries'
import { FilterIdentifier } from 'models/saved_view'

import { ColumnsStoreProvider } from 'stores/ColumnsStore/ColumnsStoreProvider'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { ChainsTableComponent } from './ChainsTableComponent'
import { chainsReportsTableVariant } from './chainsTableVariants'

export interface IChainTable {
  setChainsSummary?: (summary: ChainsSummary) => void
  baseFilters?: Record<string, any>
  tableKey: string
  filterIdentifierModifier?: FilterIdentifier
  hideCreateCompanyButton?: boolean
}

export function ChainsTable(
  props: IChainTable & {
    defaultColumnVisibility?: IColumnVisibility<any>
  }
) {
  const { tableKey, defaultColumnVisibility, ...rest } = props
  const { isLoading } = useFeatureFlagService()

  // Wait for feature flags to finish loading before mounting — the reports
  // table reads flags downstream, and mounting early would flash stale
  // content before they resolve.
  if (isLoading) {
    return null
  }

  // The CRM-reports variant is now the only variant (the legacy V1
  // `restaurants-bars` table was removed); it reads rows from `reports/chains/`.
  return (
    <ColumnsStoreProvider
      tableKey={tableKey}
      defaultColumnVisibility={defaultColumnVisibility}
      savedPresetsIdentifier={'CHAINS_TABLE'}
      preferredGroupOrder={[
        'Target Attributes',
        'Campaigns and Deals',
        'Predicted Values',
        'Reputation Data',
        'Location Data',
      ]}
    >
      <DataTableProvider tableKey={tableKey}>
        <ChainsTableComponent
          tableKey={tableKey}
          variant={chainsReportsTableVariant}
          {...rest}
        />
      </DataTableProvider>
    </ColumnsStoreProvider>
  )
}
